<template>
  <div
    v-tinymce="options"
    :key="renderKey"
    @mce-change="(table) => offerSectionSet({ [`pricingTable${name}`]: table })"
    @mce-dirty="() => $emit('dirty')">
    <div v-if="offerSections[`pricingTable${name}`]" v-html="offerSections[`pricingTable${name}`]"></div>
    <table v-else class="table mt-4">
      <tbody>
        <tr class="highlight-row">
          <td width="51%"><strong>{{ $t('pricing.services') }}</strong></td>
          <td width="15%"><strong>{{ $t('pricing.quantity') }}</strong></td>
          <td width="17%"><strong>{{ $t('pricing.unitPrice') }}</strong></td>
          <td width="17%">
            <strong>{{ $t('pricing.totalPrice') }}<br /></strong><span v-if="!isOpenSeminar">{{ $tc('pricing.participants', capacity, { count: capacity }) }}</span>
          </td>
        </tr>
        <tr>
          <td>
            {{ offer && offer.title ? offer.title : seminarTitle }}
            <span v-if="numberOfExecutions > 1"> <br />{{ $t('pricing.executions', { count: numberOfExecutions }) }} </span>
          </td>
          <td v-if="!isOpenSeminar">
            {{ duration }}
          </td>
          <td v-else>{{ $tc('pricing.participants', offer.numberOfParticipants, { count: offer.numberOfParticipants }) }}</td>
          <td v-if="!isOpenSeminar">
            {{ dailyPrice | currency
            }}<span> / {{ $tc('common.day', 1) }}</span>
          </td>
          <td v-else>{{ offer.seminarDate.price | currency }} / {{ $tc('common.participant', 1) }}</td>
          <td>
            {{ seminarPrice | currency }}
          </td>
        </tr>
        <tr v-if="offer.travelCostsIncluded && !isOpenSeminar">
          <td>{{ $t('pricing.travelCosts') }}</td>
          <td></td>
          <td>{{ $t('common.included') }}</td>
          <td>{{ $t('common.included') }}</td>
        </tr>
        <tr v-if="offer.documentsIncluded">
          <td>
            <span v-if="isOpenSeminar">{{ $t('pricing.documentsOrBook') }}</span>
            <span v-else>{{ $t('pricing.documents') }}</span>
          </td>
          <td v-if="!isOpenSeminar"></td>
          <td v-else>1 {{ $t('common.piece') }}</td>
          <td>{{ $t('common.included') }}</td>
          <td>{{ $t('common.included') }}</td>
        </tr>
        <tr v-if="offer.numberOfBooksIncluded && parseInt(offer.numberOfBooksIncluded) > 0 && !isOpenSeminar">
          <td>{{ $t('pricing.specialistBooks') }}</td>
          <td>{{ offer.numberOfBooksIncluded }} {{ $t('common.piece') }}</td>
          <td>{{ $t('common.included') }}</td>
          <td>{{ $t('common.included') }}</td>
        </tr>

        <!-- Default 2 books included if param not given -->
        <tr
          v-if="
            (typeof offer.numberOfBooksIncluded === 'undefined' || offer.numberOfBooksIncluded === null) &&
            !isOpenSeminar &&
            offer.documentsIncluded
          ">
          <td>{{ $t('pricing.specialistBooks') }}</td>
          <td>2 {{ $t('common.piece') }}</td>
          <td>{{ $t('common.included') }}</td>
          <td>{{ $t('common.included') }}</td>
        </tr>
        <tr v-if="offer && offer.isTravelExpensesAtCost && !isOpenSeminar && (name == 'Inhouse' || name == 'Firmen')">
          <td>{{ $t('pricing.travelAtCost') }}</td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr v-if="isOpenSeminar && (!isOnline || name === 'Hybrid')">
          <td>{{ $t('pricing.catering') }}</td>
          <td>{{ duration }}</td>
          <td>{{ $t('common.included') }}</td>
          <td>{{ $t('common.included') }}</td>
        </tr>
        <tr v-if="isOpenSeminar && isOnline && name !== 'Hybrid'">
          <td>{{ $t('pricing.cloudEnvironment') }}</td>
          <td>{{ duration }}</td>
          <td>{{ $t('common.included') }}</td>
          <td>{{ $t('common.included') }}</td>
        </tr>
        <tr v-for="(position, index) in additionalCostsOneTime" :key="'A' + index">
          <td>{{ additionalCostDescription(position) }}</td>
          <td>
            <span v-if="position.perDay">{{ duration }}</span>
          </td>
          <td v-if="parseInt(position.price) === 0">{{ $t('common.additional') }}</td>
          <td v-else>
            {{ position.price | currency
            }}<span v-if="position.perDay">
              / {{ $tc('common.day', 1) }}</span
            >
          </td>
          <td v-if="parseInt(position.price) === 0">{{ $t('common.additional') }}</td>
          <td v-else>
            {{ pricePosition(position) | currency }}
          </td>
        </tr>
        <tr>
          <td v-if="!isOpenSeminar">
            <strong>
              <span v-html="$tc('pricing.trainingForCapacity', capacity, { location: priceLocationLabel(name), capacity })"></span>
            </strong>
          </td>
          <td v-else>
            <strong>{{ $tc('pricing.openTrainingFor', offer.numberOfParticipants, { count: offer.numberOfParticipants }) }}</strong>
          </td>
          <td></td>
          <td></td>
          <td>
            <strong>{{ offerPrice2 | currency }}</strong
            ><!-- <br />zzgl. MwSt. -->
            <!-- <small><b class="text-muted"><br>{{ offerPrice | currency }}</b></small> -->
          </td>
        </tr>
        <tr class="highlight-row" v-if="additionalCosts && additionalCostsPerPerson.length > 0">
          <td><strong>{{ $t('pricing.additionalPerParticipant') }}</strong></td>
          <td><strong>{{ $t('pricing.quantity') }}</strong></td>
          <td><strong>{{ $t('pricing.unitPrice') }}</strong></td>
          <td>
            <strong v-html="$t('pricing.totalPerParticipant')"></strong>
          </td>
        </tr>
        <tr v-for="(position, index) in additionalCostsPerPerson" :key="'B' + index">
          <td>{{ additionalCostDescription(position) }}</td>
          <td>
            <span v-if="position.perDay">{{ duration }}</span
            ><span v-else>{{ $t('common.perPerson') }}</span>
          </td>
          <td>
            <span v-if="parseInt(position.price) === 0">{{ $t('common.additional') }}</span>
            <span v-else>
              {{ position.price | currency }}
              <span v-if="position.perDay"
                >/ {{ $tc('common.day', 1) }}</span
              ><span v-else>/ {{ $t('common.piece') }}</span>
            </span>
          </td>
          <td>
            <span v-if="parseInt(position.price) === 0">{{ $t('common.additional') }}</span>
            <span v-else-if="position.perDay">{{ (position.price * offer.duration) | currency }}</span>
            <span v-else>{{ position.price | currency }}</span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import placeholder from "./placeholder";
import { formatDuration } from "../../misc/LocaleFormat";
import { localizeAdditionalCost } from "../../misc/CombitTextClassifier";
export default {
  name: "PricingTable",
  props: {
    options: Object,
    name: String,
    additionalCosts: Array,
    title: String,
  },
  mixins: [placeholder],
  data: function () {
    return {
      renderKey: 0,
    };
  },
  computed: {
    ...mapGetters(["offer", "seminar", "offerSections"]),
    pricingException: function () {
      if (this.offer && this.offer.isRemote && this.offer.isClassroom) {
        return this.$t('pricing.remotePriceNotice');
      }
    },
    seminarTitle: function () {
      return this.seminar ? this.seminar.title : this.placeholder;
    },
    offerPrice: function () {
      return this.offer && this.offer.totalPrice ? this.offer.totalPrice : this.placeholder;
    },
    offerPrice2: function () {
      if (!this.offer) return null;
      const additionalCostsSum = this.additionalCostsOneTime.reduce((acc, pos) => acc + this.pricePosition(pos), 0);
      return this.seminarPrice + additionalCostsSum;
    },
    seminarPrice: function () {
      if (this.offer && parseInt(this.offer.offerType_id) === 4) {
        return this.offer.seminarDate.price * this.offer.numberOfParticipants;
      }
      return this.offer
        ? this.offer.ratePerDay * this.offer.duration * this.offer.numberOfExecutions
        : this.placeholder;
    },
    dailyPrice: function () {
      return this.offer ? this.offer.ratePerDay : this.placeholder;
    },
    capacity: function () {
      return this.offer ? this.offer.capacity : this.placeholder;
    },
    duration: function () {
      return this.offer && this.offer.duration
        ? formatDuration(this.offer.duration, this.offer.durationPerDay, this.offer.numberOfExecutions, this.offer.language || 'de', this.$tc.bind(this))
        : this.placeholder;
    },
    durationPerPerson: function () {
      if (!this.offer || !this.offer.duration) return this.placeholder;
      return formatDuration(this.offer.duration, this.offer.durationPerDay, 1, this.offer.language || 'de', this.$tc.bind(this));
    },
    numberOfExecutions: function () {
      return this.offer ? parseInt(this.offer.numberOfExecutions) : false;
    },
    additionalCostsPerPerson() {
      return this.additionalCosts.filter((position) => position.perPerson);
    },
    additionalCostsOneTime() {
      return this.additionalCosts.filter((position) => !position.perPerson);
    },
    isOpenSeminar() {
      return this.offer && parseInt(this.offer.offerType_id) === 4;
    },
    isFirmenSeminar() {
      return this.offer && parseInt(this.offer.offerType_id) === 3;
    },
    isOnline() {
      return this.offer && this.offer.isRemote;
    },
  },
  methods: {
    ...mapMutations(["offerSectionSet"]),
    additionalCostDescription(position) {
      return localizeAdditionalCost(position.description, this.$t.bind(this));
    },
    priceLocationLabel(name) {
      const locationKey = name.toLowerCase() === 'firmen'
        ? 'company'
        : name.toLowerCase();
      return this.$t(`pricing.locations.${locationKey}`);
    },
    pricePosition(position) {
      let price = position.price;
      if (position.perDay) {
        price *= this.offer.duration || 1;
      }
      if (position.perExecution) {
        price *= this.offer.numberOfExecutions || 1;
      }

      return price;
    },
  },
  watch: {
    offer: {
      handler: function () {
        this.renderKey++;
      },
      deep: true,
    },
    seminar: function () {
      this.renderKey++;
    },
  },
};
</script>

<style>
.tabs .card-header {
  background-color: transparent;
}
</style>
